import { AvailableSite } from '@atlassian/gic-anywhere';
import { JiraIssue, JiraProject } from '../__types__/apiUtils';
import { Option } from '../__types__/BulkConfigureTypes';

export const mapSiteToOption = (site: AvailableSite): Option => {
	return {
		label: site.displayName,
		value: site,
	};
};

export const mapProjectToOption = (project: JiraProject): Option => {
	return {
		label: project.name,
		value: project,
		avatarUrl: project.avatarUrls['48x48'],
	};
};

export const mapIssueTypeToOption = (issueType: JiraIssue): Option => {
	return {
		label: issueType.name,
		value: issueType,
		avatarUrl: issueType.iconUrl,
	};
};
